import axios,{get,post} from "@/axios";
import { Header } from "element-ui";

const base = process.env.VUE_APP_API_ROOT;
const basePlat = `${base}/open/console`
const daqcUrl = `${base}/daqc`

/**
 * 获取 RSA 公钥
 * @returns {Promise<*>}
 */
export const getPublicKeyApi = async () => {
  const url = `${base}/daqc/crypto/rsa/publicKey`;
  const res = await get(url, {}, false);
  return res.data;
};

//通过搜索企业名称获取税号和授权信息
export const searchAuthSourceMsg = async ({ keyword}) => {
  const url = `${basePlat}/commonInspect/searchAuthSourceMsg`;
  const res = await get(url, { keyword });
  return res.data;
};

//授权并发送验证码（如果需要发送验证码）
export const authAndSendCode = async (params,loginType) => {
  const url = `${basePlat}/commonAuth/v2/login/${loginType}`;
  const res = await post(url, params);
  return res.data;
};

//授权并发送验证码（如果需要发送验证码）
export const authByCode = async (params,loginType) => {
  const url = `${basePlat}/commonAuth/v2/loginByCode/${loginType}`;
  const res = await post(url, params);
  return res.data;
};


//暂存三方授权前置信息
export const savePrepare = async (params) => {
  const url = `${basePlat}/commonInspect/savePrepare`;
  const res = await post(url, params);
  return res.data;
};


//二方专用-通过登录token换取授权token
export const getAuthToken = async ({ appTypeName,authorization}) => {
  const url = `${daqcUrl}/auth/middleware/getAuthToken`;
  const res = await get(url, { appTypeName,authorization });
  return res.data;
};



//二方专用-保存授权企业信息
export const savePrepareFromSecond = async (params) => {

  const url = `${daqcUrl}/auth/middleware/savePrepare`;
  const res = await post(url, params);
  return res.data;
};



//获取预授权信息
export const getPrepareInfo = async ({ programId}) => {
  const url = `${daqcUrl}/auth/getPrepareInfo`;
  const res = await get(url, { programId });
  return res.data;
};


//二方专用-授权并发送验证码（如果需要发送验证码）
export const authAndSendCodeFromSecond = async (params,loginType) => {

  const url = `${daqcUrl}/auth/middleware/authAndSendCode/${loginType}`;
  const res = await post(url, params);
  return res.data;
};


//二方专用-授权并发送验证码（如果需要发送验证码）
export const authByCodeFromSecond = async (params,loginType) => {

  const url = `${daqcUrl}/auth/middleware/authByCode/${loginType}`;
  const res = await post(url, params);
  return res.data;
};


//分享链接的唯一标识兑换分享token同时获取授权信息
export const getSharedPrepareInfo = async ({ uniqueCode}) => {
  const url = `${daqcUrl}/auth/getSharedPrepareInfo`;
  const res = await get(url, { uniqueCode });
  return res;
};


//第三方重新发送验证码
export const reSendCode = async (params,loginType) => {

  const url = `${basePlat}/console/commonAuth/v2/sendCode/${loginType}`;
  const res = await post(url, params);
  return res.data;
};


//二方专用-重新发送验证码
export const reSendCodeFromSecond = async (params,loginType) => {

  const url = `${daqcUrl}/auth/middleware/sendCode/${loginType}`;
  const res = await post(url, params);
  return res.data;
};
// code	string
// 非必须
// name	string
// 非必须
// finish	boolean
// 非必须
// need	boolean
// 非必须

/**
 * @typedef {Object} graphicItem
 * @property {string} code - 节点编码
 * @property {string} name - 节点名称
 * @property {boolean} finish - 是否完成
 * @property {boolean} need - 是否需要
 * @property {graphicItem[]} children - 子节点
 */



// code	string
// 非必须
// name	string
// 非必须
// finish	boolean
// 非必须
// need	boolean
// 非必须

/**
 * @typedef {Object} graphicItemMap
 * @property {string} code - 节点编码
 * @property {string} name - 节点名称
 * @property {boolean} finish - 是否完成
 * @property {boolean} need - 是否需要
 * @property {graphicItemMap[]} children - 子节点
 */
/**
 * 通过skuId获取授权检测所需节点
 * @param {skuId:number} skuId
 */
export async function getProcessGraphicBySkuId({skuId}){
  const url = `${base}/open/getProcessGraphicBySkuId`;
  const res = await get(url, {skuId});
  return res.data;
}

/**
 * 通过programId获取授权检测所需节点(税安用)
 * @param {programId:number} programId
 */
export async function getTestingProcessGraphic({programId}){
  const url = `${base}/shuian-home/testing/risk/v2/getTestingProcessGraphic`;
  const res = await get(url, {programId});
  return res.data;
}

/**
 * @typedef {Object} UpdatePrepareParams
 * @property {string} programId
 * @property {string} startDate - 开始日期，格式为"yyyy-MM-dd"
 * @property {string} endDate - 结束日期，格式为"yyyy-MM-dd"
 */
/**
 * 更新三方授权前置信息
 * @param params
 * @returns {Promise<*>}
 */
export async function updatePrepare(params) {
  const url = `${basePlat}/commonInspect/updatePrepare`;
  const res = await post(url, params);
  return res.data;
}


export async function getGoodsDetail({skuId}){
  const url = `${base}/open/getGoodsDetail`;
  const res = await get(url, {skuId});
  return res.data;
}


/**
 * 重新编辑进行数据补充
 * @param {{programId:string}} params
 * @returns {Promise<*>}
 */
export async function resetDataUpload(params) {
  const url = `${base}/shuian-home/testing/risk/v2/resetDataUpload`;
  const res = await post(url, params);
  return res.data;
}
